import Actions from 'components/RecurringOrderSuggestionsModal/Sections/Actions/styled';

export default Actions;
